// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3K7pa","inputWrap":"CustomTip_inputWrap__2jBoS"};